/**
 * @desc setPassword
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.UserPasswordRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/usr/password`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
